import { Box, Divider, Paper, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { AppColors } from "@/assets/colors";
import { IProperties, pxToRem } from "@/util";
import PropertyMap from "../map/propertymap";
type props = {
  data: Partial<IProperties>;
};
export default function Mapcard({ data }: Partial<props>) {
  const { classes } = styles();
  return (
    <Paper className={`${classes.map} `}>
      <Typography className={classes.mapTxt}>Map</Typography>
      <Divider />
      <Box className={classes.mapHead}>
        <Box className={classes.mapDesc}>
          <Image
            src={"/images/overview/map.svg"}
            width={16}
            height={16}
            alt="map"
          />
          <Typography className={classes.mapHeadTxt}>
            {data?.address},
          </Typography>
        </Box>
        <Box className={classes.mapDesc}>
          <Image
            src={"/images/overview/globe.svg"}
            width={16}
            height={16}
            alt="globe"
          />
          <Typography className={classes.mapHeadTxt}>
            {data?.landmark}{" "}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.mapSub}>
        <PropertyMap center={data?.coordinate || { lat: 0, lng: 0 }} />
      </Box>
    </Paper>
  );
}

const styles = makeStyles()((theme) => ({
  mapTxt: {
    color: AppColors.secondary["450"],
    fontWeight: 700,
    fontSize: pxToRem(20),
    fontFamily: "Playfair Display",
  },
  map: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    flex: 1,
     [theme.breakpoints.down(860)]:{
      height:pxToRem(500),
       flex:'unset'
    }
  },
  mapHead: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  mapDesc: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
    alignItems: "center",
  },

  mapSub: {
    position: "relative",
    flex: 1,
  },
  mapHeadTxt: {
    fontWeight: 500,
    fontSize: pxToRem(16),
    color: AppColors.text.second,
  },
}));
